// @flow
import { Address, Coverage } from 'esm-web-pro/containers/pages/coverage/objects';
import { isEmpty } from 'lodash';
import L from 'leaflet';
import PointIconResource from 'esm-web-pro/api/resources/PointIconResource';

const OBJECT_COMPONENTS = {
    coverage: Coverage,
    address: Address,
};

const COVERAGE_EDIT_KEY = 'COVERAGE_EDIT';

const RESOURCES = {
    coverage: 'coverage.geo',
};

const addressDisplayFields = [
    't_type', 'town_id', 'q_type', 'q_name', 'str_type', 'str_name',
    'str_n', 'str_subn', 'block_n', 'entr_n', 'app_n',
];

const green = '#0074d9';
const darkGreen = '#809c17';
const grey = 'grey';
const darkBlue = '#1f77c8';
const blue = '#23aaeb';

const iconNameMarker = 'marker';
const iconNameExclamation = 'marker_exclamation';

const getAddressTitle = (address: Object) => {
    const transformed = addressDisplayFields.map(
        (f) => address[f],
    ).filter((f) => !!f);

    return transformed.join('  ');
};

const getAddressMarkerAdditionalOptions = (address: Object, focused: boolean = false) => {
    const options: Object = { riseOnHover: true };
    let iconOptions: Object = {
        // taken from L.Icon.Default
        iconSize: [28, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41],
    };
    const { coverage, is_changed: isChanged } = address;

    let iconName;
    let color;

    iconOptions.className = focused ? 'address-marker-highlighted' : 'leaflet-icon-custom';
    if (isEmpty(coverage)) {
        color = grey;
        iconName = iconNameMarker;
    } else if (coverage.type === 'full') {
        if (coverage.origin === 'specific') {
            if (!coverage.valid_from || isChanged) {
                iconName = iconNameExclamation;
                color = darkGreen;
            } else {
                iconName = iconNameExclamation;
                color = green;
            }
        } else if (coverage.valid_from && !isChanged) {
            iconName = iconNameMarker;
            color = green;
        } else {
            iconName = iconNameMarker;
            color = darkGreen;
        }
    } else if (coverage.type === 'partial') {
        if (coverage.origin === 'specific') {
            if (!coverage.valid_from || isChanged) {
                iconName = iconNameExclamation;
                color = darkBlue;
            } else {
                iconName = iconNameExclamation;
                color = blue;
            }
        } else if (coverage.valid_from && !isChanged) {
            iconName = iconNameMarker;
            color = blue;
        } else {
            iconName = iconNameMarker;
            color = darkBlue;
        }
    } else {
        iconName = iconNameExclamation;
        color = grey;
    }

    iconOptions = { ...iconOptions, iconUrl: PointIconResource.getPointIconUrl(iconName, color) };
    const { iconUrl, ...rest } = iconOptions;
    // if ('iconUrl' in iconOptions) options.icon = L.icon(iconOptions);
    options.icon = L.icon({ ...rest, iconUrl });
    return options;
};

const getAddressTitleAdditionalOptions = (address: Object, focused: boolean = false) => {
    const options: Object = { };
    const iconOptions: Object = {
        // taken from L.Icon.Default
        iconSize: focused ? [31, 47] : [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41],
    };

    iconOptions.className = 'address-custom-number';
    if (address.str_n) {
        if (address.str_subn) {
            iconOptions.iconUrl = `${address.str_n}${address.str_subn}`;
        } else if (address.entr_n) {
            iconOptions.iconUrl = `${address.str_n} Вх:${address.entr_n}`;
        } else {
            iconOptions.iconUrl = `${address.str_n}`;
        }
    } else if (address.entr_n) {
        iconOptions.iconUrl = `${address.block_n} Вх:${address.entr_n}`;
    } else {
        iconOptions.iconUrl = `${address.block_n}`;
    }

    const { iconUrl, ...rest } = iconOptions;
    if ('iconUrl' in iconOptions) options.icon = L.divIcon({ ...rest, html: iconUrl });

    return options;
};

export {
    OBJECT_COMPONENTS, RESOURCES, COVERAGE_EDIT_KEY,
    getAddressTitle, addressDisplayFields, getAddressMarkerAdditionalOptions, getAddressTitleAdditionalOptions,
};
